// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Loading from './Components/Loading';

const Home = React.lazy(() => import('./Pages/Home'));
const AboutUs = React.lazy(() => import('./Pages/AboutUs'));
const ContactUs = React.lazy(() => import('./Pages/ContactUs'));
const Services = React.lazy(() => import('./Pages/Services'));
const Employers = React.lazy(() => import('./Pages/Employers'));
const Jobseekers = React.lazy(() => import('./Pages/Jobseekers'));
const EmployersFormPage = React.lazy(() => import('./Pages/EmployersFormPage'));
const JobSeekersFormPage = React.lazy(() => import('./Pages/JobSeekersFormPage'));
const Jobs = React.lazy(() => import('./Pages/JobsListing/jobs'));
const JobApplication = React.lazy(() => import('./Pages/JobsListing/JobApplication'));
const JobDisplayOnMobile = React.lazy(() => import('./Pages/JobsListing/JobDisplayOnMobile'));
const Blogs = React.lazy(() => import('./Pages/Blogs'));

const App = () => {
  return (
    <div>
      <React.Suspense fallback={<Loading />}>
        <Header />
        <Routes>
          {/* <Route path='/' element={<UnderConstructionMsg />} /> */}
          <Route path='/' element={<Home />} />
          <Route path='/about-us' element={<AboutUs />} />
          <Route path='/job-seekers' element={<Jobseekers />} />
          <Route path='/job-seekers/job-application' element={<JobSeekersFormPage />} />
          <Route path='/job-board' element={<Jobs />} />
          <Route path='/job-board/job/display/:JobID/' element={<JobDisplayOnMobile />} />
          <Route path='/job-board/job/:JobID/' element={<JobApplication />} />
          <Route path='/employers' element={<Employers />} />
          <Route path='/employers/employees-required' element={<EmployersFormPage />} />
          <Route path='/our-services' element={<Services />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/blogs' element={<Blogs />} />
        </Routes>
        <Footer />
      </React.Suspense>
    </div>
  );
};

const AppWrapper = () => (
  <HelmetProvider>
    <Router>
      <App />
    </Router>
  </HelmetProvider>
);

export default AppWrapper;
